<template>
    <div class="dynamic-wrap">
        <div class="teaching-dynamics-content">
            <div class="data-list" :id="dynamicData.length>8?'dynamic-ul':''">
                <div class="data-box">
                    <div style="width: 50%;" v-for="(sitem, sindex) in dynamicData" :key="sindex">
                        <div class="data-box-item" v-on:click="lookTeaDynamic(sitem)"
                            :style="sindex % 2 == 0 ? `right: ${Math.floor(Math.random() * 3).toFixed(1)}vw` : `left: ${Math.floor(Math.random() * 3).toFixed(1)}vw`">
                            <div class="title">
                                {{ getSourceByType(sitem.type) }} {{ sitem.operation_time }}
                            </div>
                            <div class="info" :title="sitem.operation">
                                {{ sitem.operation.substring(19) }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <img class="center-background" :src="require('@/assets/images/sydataboard/center-bg.png')" alt="">
        <img class="left-background" :src="require('@/assets/images/sydataboard/left-bg.png')" alt="">
        <img class="right-background" :src="require('@/assets/images/sydataboard/right-bg.png')" alt="">

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { findHomeworkInfo, findResourceInfo, findInterInfo, findUserInfo } from "../../../service/api.js";

export default {
    name: "tea-dynamic",
    props: {
        dynamicData: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    data() {
        return {
            dynamicList: [],
            top: [],
            left: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
            color: ['#FFF', '#0EFCFF', '#4889FF', '#FAE17C'],
            scrollInterval: {},//动态滚动区间,
            scrollIngDynamicList: [],
            timer: null,
            hwUserSubjectId: null,
            channel: process.env.VUE_APP_CHANNEL,
        }
    },
    computed: {
        ...mapGetters([
            'homeWorkReportPath'
        ]),
        renderDynamicList: {
            get: function () {
                if (this.dynamicData.length > 0) {
                    return this.initDynamicData(this.dynamicData);
                }
            }
        }
    },
    methods: {
        /**
* @name 获取来源
*/
getSourceByType(type){
        let name = ''
        switch(type){
            case 1:
                name = '作业';
                break;
            case 2:
                name = '资源';
                break;
            case 3:
                name = '评价';
                break;
            case 4:
                name = '互动';
                break;
            case 6:
                name = '题库';
                break;
            case 7:
                name = '活动评审';
                break;
            case 8:
                name = '名师工作室';
                break;
            case 9:
                name = '集体备课';
                break;
            case 10:
                name = '听评课';
                break;
            case 11:
                name = '特色活动';
                break;
            case 12:
                name = '在线课程';
                break;
        }
        return name
    },
        /**
         * 初始化实时动态top,left,color
         */
        initDynamicData(list) {
            let _this = this;
            let minTop = 45;
            let newList = [];
            //判断动态是否小于9条 小于9条则复制3份 实现从底部滚动的效果
            if (list.length < 9) {
                for (let i = 0; i < 3 * list.length; i++) {
                    let dynamicObj = {};
                    dynamicObj.id = list[i % list.length].id;
                    dynamicObj.operation = list[i % list.length].operation;
                    dynamicObj.operation_time = list[i % list.length].operation_time;
                    dynamicObj.realname = list[i % list.length].realname;
                    dynamicObj.type = list[i % list.length].type;
                    dynamicObj.tempIndex = i;
                    newList.push(dynamicObj);
                }
            } else {
                newList = list;
            }

            for (let i = 1; i <= newList.length; i++) {
                let curTop = i * minTop;
                _this.top.push(curTop);

            }
            for (let j = 0; j < newList.length; j++) {
                var leftIndex = parseInt(_this.left.length * Math.random());
                newList[j]['left'] = _this.left[leftIndex];
                var colorIndex = parseInt(4 * Math.random());
                newList[j]['top'] = _this.top[j];
                newList[j]['color'] = _this.color[colorIndex];
            }

            _this.scrollInterval.minTop = minTop;
            _this.scrollInterval.maxTop = minTop * newList.length - 30;

            this.timer = setInterval(_this.dynamicScroll, 20);
            return newList;

        },
        /**
         * 鼠标悬停停止滚动
         */
        hoverEvent() {
            clearInterval(this.timer);
        },
        /**
         * 鼠标离开继续滚动
         */
        mouseleaveEvent() {
            this.timer = setInterval(this.dynamicScroll, 20);
        },
        /**
         * 动态滚动效果
         */
        dynamicScroll() {
            let _this = this;
            let arr = this.$refs.dynamicUl.children;
            for (var i = 0; i < arr.length; i++) {
                if (_this.scrollIngDynamicList.length != arr.length) {
                    _this.scrollIngDynamicList[i] = arr[i].offsetTop;

                }
                arr[i].style.top = _this.scrollIngDynamicList[i] + "px";
                _this.scrollIngDynamicList[i]--;
                if (_this.scrollIngDynamicList[i] < -30) {
                    _this.scrollIngDynamicList[i] = _this.scrollInterval.maxTop;
                }
            }
        },
        /**
         * 点击事实动态查看详情
         */
        lookTeaDynamic(dynamicObj) {
            if (this.channel != 'sy') {
                //type:1：作业  2：资源  3：互动
                if (dynamicObj.type === 1) {
                    //获取作业详情
                    this.getHomeWorkInfo(dynamicObj.id);
                } else if (dynamicObj.type === 2) {
                    //获取资源详情
                    this.getResourceInfo(dynamicObj.id);
                } else if (dynamicObj.type === 3 || dynamicObj.type === 4) {
                    //获取互动详情
                    this.getInterInfo(dynamicObj.id);
                }
            }

        },
        /**
         * 获取作业详情
         */
        async getHomeWorkInfo(id) {
            let _this = this;
            let params = {
                workId: id,
            }
            let homeworkInfo = await findHomeworkInfo(params).catch(function (error) {
                _this.$Message.error(error.message);
            });
            if (homeworkInfo != null && homeworkInfo.id != undefined) {
                //获取用户姓名
                _this.findUserSubjectByUserId(homeworkInfo.teaid, homeworkInfo.id, homeworkInfo.title, homeworkInfo.hwtype, homeworkInfo.hwtypecode);
            } else {
                this.$Message.error("暂未找到该作业信息！");
                return;
            }
        },
        /**
         * 点击查看作业报告
         */
        lookWorkReport(userId, homeworkId, homeworkName, hwType, hwTypeCode) {
            let reportUrl = "";
            //答题卡
            if (hwType == 0) {
                reportUrl = this.homeWorkReportPath + '/report/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
            } else if (hwType == 1) {

                if (hwTypeCode == '103') {
                    //菁优题库
                    reportUrl = this.homeWorkReportPath + '/jingyouReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                } else if (hwTypeCode == '104' || hwTypeCode == '110') {
                    //校本题库
                    reportUrl = this.homeWorkReportPath + '/xbReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                } else if (hwTypeCode == '108') {
                    //学科网
                    reportUrl = this.homeWorkReportPath + '/xkwReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                } else {
                    //题库
                    reportUrl = this.homeWorkReportPath + '/questionBankReport/' + userId + '/' + homeworkId + '/' + homeworkName + '/' + hwType + '/web?hwtypecode=' + hwTypeCode + '&subjectId=' + this.hwUserSubjectId;
                }
            }
            window.open(reportUrl, "_blank");
        },
        /**
         * 根据用户id查询学科id
         */
        async findUserSubjectByUserId(userId, homeworkId, homeworkName, hwType, hwTypeCode) {
            let _this = this;
            let userParam = {
                userId: userId
            };

            let userData = await findUserInfo(userParam).catch(function (error) {
                _this.$Message.error(error.message);
            });

            _this.hwUserSubjectId = userData.subjectid;
            //点击查看作业报告
            _this.lookWorkReport(userId, homeworkId, homeworkName, hwType, hwTypeCode);
        },
        /**
         * 获取资源详情
         */
        async getResourceInfo(id) {
            let _this = this;
            let params = {
                id: id
            }
            let resourceInfo = await findResourceInfo(params).catch(function (error) {
                _this.$Message.error(error.message);
            });
            if (resourceInfo != null) {
                //通知父页面
                _this.$emit(
                    "openPreview",
                    resourceInfo.resultUrl,
                    resourceInfo.imgCount, resourceInfo.fileType
                );
            } else {
                this.$Message.error("暂未找到该资源信息！");
                return;
            }
        },
        /**
         * 获取课堂互动详情
         */
        async getInterInfo(id) {
            let _this = this;
            let params = {
                id: id
            }
            let interInfo = await findInterInfo(params).catch(function (error) {
                _this.$Message.error(error.message);
            });
            if (interInfo != null) {
                //通知父页面
                _this.$emit(
                    "lookInterInfo",
                    interInfo
                );
            } else {
                this.$Message.error("暂未找到该课堂互动信息！");
                return;
            }
        }
    },
    destroyed() {
        //组件销毁时手动销毁事件
        clearInterval(this.timer);
    }
}
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";

.center-background {
    height: calc(100% - 70px);
    width: auto;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
}

.left-background {
    width: auto;
    height: 100%;
    position: absolute;
    top: 0;
    left: -5px;
}

.right-background {
    width: auto;
    height: 100%;
    position: absolute;
    top: 0;
    right: -5px;
}

.teaching-dynamics-content {
    width: calc(100% - 60px);
    height: calc(100% - 20px);
    position: relative;
    overflow: hidden;
    margin: 0 auto;

    .data-list {
        width: 100%;
        // height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        // justify-content: center;
        position: relative;
        z-index: 2;
    }

    #dynamic-ul {
        &.data-box {
            cursor: pointer;
        }

        // height: 100%;
        animation: infinitevertical 30s linear infinite;

        &:hover {
            animation-play-state: paused;
        }

    }

    /* 无限滚动垂直 */
    @keyframes infinitevertical {
        0% {
            transform: translateY(0%);
        }

        100% {
            transform: translateY(-25%);
        }
    }

    .data-box {
        width: 100%;
        display: flex;
        align-items: center;
        display: flex;
        // flex-direction: column;
        justify-content: space-between;
        flex-wrap: wrap;
        position: relative;
        z-index: 2;

        // margin-bottom: 65px;

        // margin: 20px 0;
        .data-box-item {
            display: inline-block;
            width: 250px;
            // width: 50%;
            margin-bottom: 35px;
            // padding: 0 10px;
            padding: 0 15px;
            color: #FFFFFF;
            text-align: left;
            position: relative;
            cursor: pointer;
            background: linear-gradient(-2deg, #2465CF 0%, transparent 60%);

            .title {
                font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
                margin-bottom: 10px;
            }

            .info {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            &:hover {
                background: linear-gradient(0deg, #D88815 0%, #0C1947 100%);
            }
        }
    }
}
</style>

